import { safeDefine } from "../../registration/safe-define.js";
import { MinimalAudioSkinElement } from "../../presets/audio/minimal-skin.js";
import "../../internal/skins/minimal-audio/register.js";
//#region src/define/audio/minimal-skin.ts
safeDefine(MinimalAudioSkinElement);
//#endregion
